@if (showFulfilmentDetails()) {
    @if (recentOrder().orderInitiation.transferTargetId) {
        <div class="order-transfer"
             [innerHTML]="('woa.message.order.summary.transferredToGroupOrder' | translate: {
                            'store': recentOrder().initiatedOrder.store.collectiveStoreName,
                            'groupOrderName': recentOrder().orderInitiation.transferTargetName | possessive
                    }) | html">
        </div>
    }
    @if (!recentOrder().orderInitiation.transferTargetId) {
        @if (recentOrder().placedOrder.requestId) {
            @if (showOrderNumberQrCode()) {
                <div class="order-qr">
                    <div class="order-qr-label">{{ 'woa.label.order.details.qrCode' | translate }}</div>
                    <woa-qr-code-panel [value]="recentOrder().placedOrder.lookupCode"
                                       [displayValue]="recentOrder().placedOrder.receiptId"
                                       message="{{'woa.label.order.details.qrCode' | translate}}"></woa-qr-code-panel>
                    <div class="order-qr-value">{{ recentOrder().placedOrder.receiptId }}</div>
                </div>
            }
            @if (!showOrderNumberQrCode()) {
                <div class="order-receiptId"
                     [ngClass]="{'more-details': orderTimeLabel() || recentOrder().orderPlacement.waiterName}"
                     [innerHTML]="'woa.label.order.details.receiptId' | translate: {receiptId: recentOrder().placedOrder.receiptId} | html"></div>
            }
        }
        @if (orderTimeLabel()) {
            <div class="order-time" [ngClass]="{'more-details': recentOrder().orderPlacement.waiterName}"
                 [innerHTML]="orderTimeLabel() | translate:{time: orderTime()} | html"></div>
        }
    }
}
@if (recentOrder().orderPlacement.waiterName) {
    <div class="order-waiter"
         [innerHTML]="'woa.label.order.details.waiter' | translate: {waiterName: recentOrder().orderPlacement.waiterName} | html"></div>
}
@if (showLocationDetails() && !recentOrder().orderInitiation.transferTargetId && recentOrder().orderInitiation.orderTypeEnum !== OrderType.ORDER_AT_TABLE) {
    <woa-store-details-panel class="order-store" [summary]="true"
                             [store]="recentOrder().initiatedOrder.store"
                             [intention]="OrderingContextIntention.NONE"
                             [showStoreImage]="false" [showMoreDetails]="false"
                             [showStatus]="false" [showTelephone]="true"
                             [showActions]="false" [showMap]="true"></woa-store-details-panel>
}
@if (showFulfilmentDetails() && !recentOrder().orderInitiation.transferTargetId && recentOrder().placedOrder.requestId && recentOrder().orderInitiation.orderTypeEnum === OrderType.ORDER_DELIVERY) {
    <woa-field-group class="delivery-address" [title]="'woa.label.order.details.deliveringTo'">
        <div class="delivery-address-details">{{ recentOrder().orderPlacement.address.formattedAddress }}</div>
        <div class="delivery-address-mobile">{{ 'woa.label.order.details.phoneNumber' | translate: {'phoneNumber': recentOrder().orderPlacement.mobilePhone} }}</div>
        @if (recentOrder().orderPlacement.deliveryInstructions) {
            <div class="delivery-address-instructions">{{ recentOrder().orderPlacement.deliveryInstructions }}</div>
        }
    </woa-field-group>
}
@if (showOrderDetails()) {
    @for (requestDetails of transferRequestDetails(); track requestDetails; let i = $index) {
        @if (requestDetails.items.length) {
            <woa-field-group class="order-request"
                             [title]="simpleRequestHeading() ?? requestDetails.heading"
                             [translationParams]="{name: requestDetails.name}">
                @for (item of requestDetails.items; track item; let j = $index) {
                    <div class="order-request-item" id="order-request-item-{{i}}.{{j}}">
                        <div class="order-request-item-qty">
                            {{ item.quantitySignal() }}
                        </div>
                        <div class="order-request-item-details">
                            <div class="order-request-item-details-header">
                                @if (item.dealIdSignal()) {
                                    <woa-icon class="order-request-item-details-header-icon"
                                              [name]="'tags'"></woa-icon>
                                }
                                <div class="order-request-item-details-header-name">
                                    {{ item.nameSignal() }}
                                </div>
                            </div>
                            @for (component of item.compositeComponentsSignal(); track component) {
                                <div class="order-request-item-details-component">
                                    <div class="order-request-item-details-component-name">
                                        {{ component.nameSignal() }}
                                    </div>
                                    @if (component.orderedExtrasSignal()?.length) {
                                        <woa-order-extras-panel class="order-request-item-details-component-extras"
                                                                [showTotal]="true"
                                                                [item]="component"></woa-order-extras-panel>
                                    }
                                </div>
                            }
                            @if (!item.compositeComponentsSignal()?.length && item.orderedExtrasSignal()?.length) {
                                <woa-order-extras-panel class="order-request-item-details-extras"
                                                        [showTotal]="true"
                                                        [item]="item"></woa-order-extras-panel>
                            }
                            <div class="order-request-item-details-notes"
                                 [innerHTML]="item.itemNotesSignal() | html"></div>
                        </div>
                        <div class="order-request-item-total">
                            {{ (item.initiatedTotalSignal() ?? item.localTotalSignal()) | woaCurrency }}
                        </div>
                    </div>
                }
                @if (totalTransfers()) {
                    <div class="order-request-subtotal">
                        <div class="order-request-subtotal-label">
                            {{ requestDetails.subtotalLabel | translate: {name: requestDetails.name} }}
                        </div>
                        <div class="order-request-subtotal-price">
                            {{ requestDetails.subTotal | woaCurrency }}
                        </div>
                    </div>
                }
            </woa-field-group>
        }
    }
    @if (!recentOrder().orderInitiation.transferTargetId &&
    ((recentOrder().orderPlacement.requestId && recentOrder().orderPlacement.customerNotes) ||
        (!recentOrder().orderPlacement.requestId && orderModel.orderNotes()))) {
        <woa-field-group class="order-notes" [title]="'woa.heading.order.notes'">
            <div class="order-notes-text">{{ recentOrder().orderPlacement.requestId ? recentOrder().orderPlacement.customerNotes : orderModel.orderNotes() }}</div>
        </woa-field-group>
    }
    @if (showPayment() && !recentOrder().orderInitiation.transferTargetId) {
        <woa-field-group class="order-payment"
                         [title]="'woa.heading.order.paymentDetails'">
            <woa-order-totals-panel class="order-payment-totals" [recentOrder]="recentOrder()"
                                    [showZeroTip]="false" [showSavings]="false"
                                    [canEditTip]="false"></woa-order-totals-panel>
            @if (recentOrder().orderPlacement.requestId && totalPayment() > 0) {
                <div class="order-payment-method">
                    @if (recentOrder().orderPlacement.paymentAuthorisation.paymentCardBrand &&
                    (recentOrder().orderPlacement.paymentAuthorisation.paymentType === PaymentType.SAVED_CREDIT_CARD ||
                        recentOrder().orderPlacement.paymentAuthorisation.paymentType === PaymentType.NEW_CREDIT_CARD ||
                        recentOrder().orderPlacement.paymentAuthorisation.paymentType === PaymentType.TAP_TO_PAY)) {
                        <woa-card-brand class="order-payment-method-brand"
                                        [brand]="recentOrder().orderPlacement.paymentAuthorisation.paymentCardBrand"></woa-card-brand>
                    }
                    <div class="order-payment-method-details">{{
                            paymentMethod() | translate: {
                                points: memberAvailableRedemptionPoints(),
                                card: recentOrder().orderPlacement.paymentAuthorisation.paymentCardLast4
                            }
                        }}
                    </div>
                </div>
            }
            @if (!recentOrder().pending && recentOrder().orderPlacement.requestId && totalPayment() > 0 && configurationModel.app()?.orderReceivedEmail.id) {
                <woa-button class="order-payment-action"
                            [label]="'woa.button.order.sendInvoice'" [prominence]="ButtonProminence.LOW"
                            (onActivate)="requestInvoice()"></woa-button>
            }
        </woa-field-group>
    }
}
